import { render, staticRenderFns } from "./ComparisonChart.vue?vue&type=template&id=64f11414&scoped=true&"
import script from "./ComparisonChart.vue?vue&type=script&lang=js&"
export * from "./ComparisonChart.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonChart.vue?vue&type=style&index=0&id=64f11414&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f11414",
  null
  
)

export default component.exports